import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ToolbarButtons extends Component {
  onPopupClick = (name, download_option) => {
    const { case_uuid, court_code, case_number, visibleDocketNums, getDocketParts, updateDocketParts } = this.props;

    const params = {
      case_uuid,
      court_code,
      case_number,
      docket_numbers: visibleDocketNums,
    };

    if (download_option) {
      params.download_option = download_option;
    }

    getDocketParts(params);

    this.props.onPopupClick({
      name,
      show: true,
      data: params,
    });

    // do we need this here?
    updateDocketParts({});
  };

  render() {
    const { toggleHeader } = this.props;

    return (
      <div id="docket-toolbar-buttons" className="right menu">
        <a className="item "
           onClick={toggleHeader}
           title="Toggle Docket Header Display">
          <span className="expand icon" /> Header
        </a>

        <div className="ui delayed dropdown item">
          <span className="printer icon" /> Print
          <div className="menu">
            <div className="item"
                 title="Prints Docket Sheet and Header (if visible) "
                 onClick={window.print_preview}>
              <span className="text page icon" /> Docket Sheet
            </div>
            <div className="item"
                 title="Opens bulk docket download and combine form"
                 onClick={this.onPopupClick.bind(null, 'PrintAllPdfInRangePopup', 0)}>
              <span className="pdf icon" /> All PDFs in range
            </div>
          </div>
        </div>
        <div className="ui delayed dropdown item " id="docket-download-menu">
          <span className="download icon" /> Download
          <div className="menu">
            <div className="item" onClick={this.onPopupClick.bind(null, 'DownloadZipAllPdfsRangePopup', 1)}>
              <span className="zip icon" /> ZIP all PDFs in range
            </div>
            <div className="item" onClick={this.onPopupClick.bind(null, 'DownloadZipWithSubpartsPopup', 1)}>
              <span className="zip icon" /> ZIP with subparts combined
            </div>
            <div className="item" onClick={this.onPopupClick.bind(null, 'DownloadCombineAllPdfInRangePopup', 1)}>
              <span className="pdf icon" /> Combine all PDFs in range
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ToolbarButtons.propTypes = {
  visibleDocketNums: PropTypes.array.isRequired,
  case_uuid: PropTypes.string.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  toggleHeader: PropTypes.func.isRequired,
  updateDocketParts: PropTypes.func.isRequired,
  getDocketParts: PropTypes.func.isRequired,
};

export default ToolbarButtons;



// WEBPACK FOOTER //
// ./src/components/case/docket/ToolbarButtons.jsx